import { graphql, useFragment } from 'react-relay';

import { useSellerRating_seller$key } from './__generated__/useSellerRating_seller.graphql';

const sellerFragment = graphql`
    fragment useSellerRating_seller on Seller {
        orderFeedbackPdp {
            metadata {
                aggregatedFeedback {
                    overallExperience {
                        mean
                    }
                }
            }
        }
    }
`;

export const useSellerRating = ({
    seller: sellerRef,
}: {
    seller: useSellerRating_seller$key | null | undefined;
}): number => {
    const seller = useFragment(sellerFragment, sellerRef);
    const ratingMean =
        seller?.orderFeedbackPdp?.metadata?.aggregatedFeedback?.overallExperience?.mean;

    return ratingMean ? parseFloat(ratingMean.toFixed(1)) : 0;
};
